import { Component } from '@angular/core';

@Component({
  selector: 'app-migration-landing',
  templateUrl: './migration-landing.component.html',
  styleUrls: ['./migration-landing.component.scss']
})
export class MigrationLandingComponent {
  searchCriteria:any
}
